<template>
  <Page class="skill-page" :pagination="`${page}/${total_pages}`">
    <template #content>
      <span
        class="page-title"
        v-text="modules[moduleIndex].name.toUpperCase()"
      />
      <div class="header-note">
        <Tag
          style="margin: 12px auto 24px; font-size: 30px"
          class="yellow bold"
          :text="moduleItem.label"
          :data-convert="`${result.module}_circular`"
        />
        <p
          class="appreciation bold"
          v-text="moduleItem.analysis"
        />
      </div>
      <div class="content-wrapper">
        <div class="content-block">
          <div class="content-title">LES AVANTAGES :</div>
          <div
            class="content"
            v-text="moduleItem.plus"
          />
        </div>
        <div class="content-block">
          <div class="content-title">LES INCONVÉNIENTS :</div>
          <div
            class="content"
            v-text="moduleItem.minus"
          />
        </div>
      </div>
      <div
        v-if="currentCampaign.version === 1"
        class="badge-wrapper"
        :class="`position-${candidate_position}`"
        :data-convert="`${result.module}_badge`"
      >
        <div class="badge-inner">
          <Badge
            :position="candidate_position"
            :module="result.module"
            :use_gradients="false"
            data-html2canvas-ignore
          />
        </div>

        <div class="badge-content" data-html2canvas-ignore>
          <p class="bold">Compétence N°{{ candidate_position }} :</p>
          <p>
            Pour cette compétence, voici le badge obtenu par ce profil sur son
            rapport de participant. Vous pouvez le mentionner lors de vos
            échanges.
          </p>
        </div>
        <div class="badge-tag">
          <div class="badge-tag-hidden">Badge {{ position_label }}</div>
          <div class="badge-tag-shown" data-html2canvas-ignore>
            Badge {{ position_label }}
          </div>
        </div>
      </div>
    </template>
  </Page>
  <Page :pagination="`${page + 1}/${total_pages}`">
    <template #content>
      <span
        class="page-title"
        v-text="modules[moduleIndex].name.toUpperCase()"
      />
      <div class="content-wrapper">
        <div class="content-block">
          <div class="content-title">Définition :</div>
          <div
            class="content"
            v-html="modules[moduleIndex].result_wordings.skill_description"
          />
        </div>
        <div class="content-block">
          <div class="content-title">Son importance :</div>
          <div class="content">
            <div
              v-for="advantage in modules[moduleIndex].result_wordings
                .advantages"
              :key="advantage"
              class="avantage"
            >
              <div class="icon-container">
                <i class="yuzu-icon" :class="advantage.icon" />
              </div>
              <p v-html="advantage.text" />
            </div>
          </div>
        </div>
        <div class="content-block">
          <div class="content-title">
            3 questions pour approfondir cette évaluation :
          </div>
          <div class="content">
            <ol>
              <li
                v-for="(question, index) in moduleItem.questions"
                :key="index"
                v-text="question"
              />
            </ol>
            <p
              v-if="currentCampaign.version === 1"
              v-html="moduleItem.questions_info"
            />
          </div>
        </div>
      </div>
    </template>
  </Page>
</template>

<script setup>
import { computed } from "vue";
import { useModulesStore } from "@/stores/modules.js";
import { useCampaignStore } from "@/stores/campaign.js";
import Page from "../Page.vue";
import Badge from "@/components/game/badges/Badge.vue";

const { modules } = useModulesStore();

const { currentCampaign } = useCampaignStore();

const props = defineProps({
  result: {
    type: Object,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
  total_pages: {
    type: Number,
    required: true,
  },
});

const page = computed(() => {
  return props.index * 2 + 3;
});

const moduleIndex = computed(() => {
  if (currentCampaign.version === 1) {
    return modules.findIndex((elt) => elt.id === props.result.module);
  }

  return modules.findIndex(
    (elt) =>
      props.result.module.includes(elt.id_v2) ||
      props.result.module.includes(elt.id)
  );
});

const candidate_position = computed(() => {
  return props.result.badge_rank;
});

const position_label = computed(() => {
  const labels = ["Or", "Argent", "Bronze"];

  return labels[candidate_position.value - 1];
});

const moduleItem = computed(() => {
  return Object.values(modules[moduleIndex.value].result_wordings).find(
    (elt) => elt.id === props.result.id
  );
});
</script>
